<div class="main-container">
  <app-header></app-header>
  <app-alerts-handler></app-alerts-handler>
  <div class="content-container">
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</div>
